const $ = require("jquery");

/*
 * Google Ads conversions. До согласия на cookies gtag() — заглушка (см. config.php).
 * request и form_submit отправляются из config.php по загрузке form_* / success_*.
 */
function conversion(label) {
	gtag('event', 'conversion', {
		'send_to': 'AW-11191154034/' + label,
		'value': 1.0,
		'currency': 'EUR'
	});
}

$(document).on('click', 'a[href^="tel:"]', function() {
	conversion('O5ZQCJOuoZsdEPLqrdgp'); // phone
});

$(document).on('click', 'a[href^="mailto:"]', function() {
	conversion('iMhICOqOqpsdEPLqrdgp'); // email
});
